import axios from "axios";

export default function ApprovalQueue({ queue, API, onRefresh }) {
  const approve = async (id) => {
    await axios.post(`${API}/queue/${id}/approve`);
    onRefresh();
  };

  const reject = async (id) => {
    await axios.post(`${API}/queue/${id}/reject`);
    onRefresh();
  };

  return (
    <div style={card}>
      <h2 style={heading}>
        Approval Queue
        {queue?.length > 0 && (
          <span style={badge}>{queue.length} pending</span>
        )}
      </h2>

      {!queue?.length ? (
        <p style={empty}>No signals awaiting approval</p>
      ) : (
        queue.map(item => (
          <div key={item.signal_id} style={queueItem}>
            <div style={itemHeader}>
              <span style={symbol}>{item.signal.symbol}</span>
              <span style={timer}>{item.minutes_remaining}m remaining</span>
            </div>
            <div style={details}>
              <span>Setup: {item.signal.setup || "—"}</span>
              <span>Entry: {item.signal.price}</span>
              <span>SL: {item.signal.stop_loss}</span>
              <span>TP: {item.signal.take_profit}</span>
            </div>
            <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
              <button
                onClick={() => approve(item.signal_id)}
                style={{ ...btn, background: "#1D9E75" }}
              >
                Approve
              </button>
              <button
                onClick={() => reject(item.signal_id)}
                style={{ ...btn, background: "#e24b4a" }}
              >
                Reject
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

const card = {
  background: "#1a1a1a",
  borderRadius: "12px",
  padding: "20px",
  border: "1px solid #2a2a2a"
};
const heading = {
  margin: "0 0 16px",
  fontSize: "14px",
  fontWeight: "600",
  color: "#ffffff",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  display: "flex",
  alignItems: "center",
  gap: "8px"
};
const badge = {
  background: "#BA7517",
  color: "#fff",
  borderRadius: "12px",
  padding: "2px 8px",
  fontSize: "11px"
};
const empty = {
  color: "#555",
  fontSize: "13px",
  textAlign: "center",
  padding: "20px 0"
};
const queueItem = {
  background: "#222",
  borderRadius: "8px",
  padding: "12px",
  marginBottom: "10px",
  border: "1px solid #333"
};
const itemHeader = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "8px"
};
const symbol = {
  fontWeight: "700",
  fontSize: "15px",
  color: "#fff"
};
const timer = {
  fontSize: "12px",
  color: "#BA7517"
};
const details = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "4px",
  fontSize: "12px",
  color: "#888"
};
const btn = {
  flex: 1,
  padding: "8px",
  borderRadius: "8px",
  border: "none",
  color: "#fff",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer"
};